import axios from "axios";

let baseApi = "https://mubashircurtainrecieptbackend.vercel.app";
// let baseApi = "http://localhost:5000";

let api = axios.create({
  baseURL: baseApi,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("mubashirCurtainToken")}`,
  },
});

let Get = async (apiName, id, params) => {
  return await new Promise((resolve, reject) => {
    api
      .get(`${apiName}${id ? "/" + id : ""}`, { params: params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
let Post = async (apiName, body) => {
  return await new Promise((resolve, reject) => {
    api
      .post(`${apiName}`, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
let Put = async (apiName, body, id) => {
  return await api.put(`${apiName}/${id ? id : ''}`, body);
};
let Delete = async (apiName, id) => {
  return await api.delete(`${apiName}/${id}`);
};


export { Get, Post, Delete, Put };
